import SidebarStore from './sidebar-store';
import DevicesStore from './devices-store';
import DiagnoseStore from './diagnose-store';
import BatchStore, { type BatchStoreWithMixins } from './batch-store';
import PacStore from './pac-store';
import NewAuthStore from '../modules/newAuth/store/new-auth-store';
import PacSimulatorStore from './pac-simulator-store';
import MaterialStore from './material-store';
import JogStore from './jog-store';
import CutoffStore from './cutoff-store';
import ShipHistoryStore from './ship-history-store';
import ScheduleStore from './schedule-store';
import MixStore from './mix-store';
import TicketStore from './ticket-store';
import SettingsStore from './settings-store';
import DischargeStore from './discharge-store';
import NotifierStore from './notifier-store';
import WebsocketStore from './websocket-store';
import WeatherStore from './weather-store';
import PrintStore from './print-store';
import ConnectionStore from './connection-store';
import BatchLogicStore from './batch-logic-store';
import RemoteDisplayStore from './remote-display-store';
import ScoreboardStore from './scoreboard-store';
import HaulerStore from './hauler-store';
import LocationsStore from './locations-store';
import AsyncStore from './async-store';
import BannerStore from '../modules/conditionalBanner/stores/banner-store';
import ProxyVersionStore from './proxy-version-store';
import LockableButtonStore from './lockable-button-store';
import SlumpTableStore from './slump-table-store';
import ManualAddStore from './manual-add-store';

class RootStore {
  connectionStore: ConnectionStore;
  bannerStore: BannerStore;
  newAuthStore: NewAuthStore;
  websocketStore: WebsocketStore;
  asyncStore: AsyncStore;
  sidebarStore: SidebarStore;
  devicesStore: DevicesStore;
  pacStore: PacStore;
  pacSimulatorStore: PacSimulatorStore;
  diagnoseStore: DiagnoseStore;
  batchStore: BatchStoreWithMixins;
  materialStore: MaterialStore;
  jogStore: JogStore;
  cutoffStore: CutoffStore;
  shipHistoryStore: ShipHistoryStore;
  scheduleStore: ScheduleStore;
  mixStore: MixStore;
  ticketStore: TicketStore;
  settingsStore: SettingsStore;
  dischargeStore: DischargeStore;
  notifierStore: any;
  weatherStore: WeatherStore;
  printStore: PrintStore;
  batchLogicStore: BatchLogicStore;
  remoteDisplayStore: RemoteDisplayStore;
  scoreboardStore: ScoreboardStore;
  haulerStore: HaulerStore;
  locationsStore: LocationsStore;
  proxyVersionStore: ProxyVersionStore;
  lockableButtonStore: LockableButtonStore;
  slumpTableStore: SlumpTableStore;
  manualAddStore: ManualAddStore;

  constructor() {
    this.connectionStore = new ConnectionStore(this);
    this.bannerStore = new BannerStore();
    this.newAuthStore = new NewAuthStore(this);
    this.settingsStore = new SettingsStore(this);
    this.websocketStore = new WebsocketStore(this);
    this.asyncStore = new AsyncStore(this);
    this.sidebarStore = new SidebarStore(this);
    this.devicesStore = new DevicesStore(this);
    this.pacStore = new PacStore(this);
    this.pacSimulatorStore = new PacSimulatorStore(this);
    this.diagnoseStore = new DiagnoseStore(this);
    this.batchStore = new BatchStore(this) as BatchStoreWithMixins;
    this.materialStore = new MaterialStore(this);
    this.jogStore = new JogStore(this);
    this.cutoffStore = new CutoffStore(this);
    this.shipHistoryStore = new ShipHistoryStore(this);
    this.scheduleStore = new ScheduleStore(this);
    this.mixStore = new MixStore(this);
    this.ticketStore = new TicketStore(this);
    this.dischargeStore = new DischargeStore(this);
    this.notifierStore = new NotifierStore();
    this.weatherStore = new WeatherStore(this);
    this.printStore = new PrintStore(this);
    this.batchLogicStore = new BatchLogicStore(this);
    this.remoteDisplayStore = new RemoteDisplayStore(this);
    this.scoreboardStore = new ScoreboardStore(this);
    this.proxyVersionStore = new ProxyVersionStore(this);
    this.lockableButtonStore = new LockableButtonStore();
    this.haulerStore = new HaulerStore(this);
    this.locationsStore = new LocationsStore(this);
    this.slumpTableStore = new SlumpTableStore(this);
    this.manualAddStore= new ManualAddStore(this);
  }
}

export default RootStore;
